import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicePage.css';

function HardwareMaintenance() {
  const navigate = useNavigate();
  return (
    <div className="service-page">
      <header className="service-header">
        <h1>Hardware Maintenance</h1>
        <p>Comprehensive maintenance and on-site support for your hardware infrastructure.</p>
      </header>
      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>
      <div className="service-container">
        <section className="service-section">
          <h3>Services</h3>
          <ul>
            <li>Server & network repairs</li>
            <li>POS device servicing</li>
            <li>Regular preventive maintenance</li>
          </ul>
        </section>

        <div className="service-cta">
          <a href="/contact">Book On-site Support</a>
        </div>
      </div>
    </div>
  );
}

export default HardwareMaintenance;
